import type { PaletteTranslation } from './en';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const paletteUr: PaletteTranslation = {
  open: 'صفحات تلاش کریں',
  button: 'تلاش کریں',
  title: 'کسی صفحے پر جائیں',
  description:
    'وہ صفحہ ڈھونڈنے کے لیے ٹائپ کریں جو آپ کھول سکتے ہیں۔ چننے کے لیے تیر والی کلیدیں، کھولنے کے لیے Enter دبائیں۔',
  placeholder: 'صفحے کا نام لکھیں، جیسے معلومات یا ٹیم اور رسائی',
  empty: '“{{query}}” سے کوئی صفحہ نہیں ملتا۔',
  emptyHint: 'کوئی اور لفظ آزمائیں۔ صرف وہی صفحات دکھائے جاتے ہیں جو آپ کھول سکتے ہیں۔',
  current: 'آپ یہاں ہیں',
  account: 'آپ کا اکاؤنٹ',
  hint: {
    move: 'منتقل ہونے کے لیے',
    open: 'کھولنے کے لیے',
    close: 'بند کرنے کے لیے',
  },
};
